// Curtain / blind. Commands: OPENCURTAIN / CLOSECURTAIN / STOPCURTAIN
// (uppercase, matching the Flutter app / firmware).

import React from 'react';
import { Stack, Button } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import StopIcon from '@mui/icons-material/Stop';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import DeviceShell from '../../components/DeviceShell';
import { useApp } from '../../state/AppContext';
import { publishCommand } from '../../utils/deviceController';

export default function CurtainScreen({ device }) {
  const { userId } = useApp();
  const uno = device.UniqueNumber;
  const send = (cmd) => publishCommand(uno, cmd, userId);

  return (
    <DeviceShell title={device.DeviceName || uno}>
      <Stack spacing={2} sx={{ mt: 2 }}>
        <Button variant="contained" size="large" startIcon={<ArrowUpwardIcon />}
          sx={{ py: 2 }} onClick={() => send('OPENCURTAIN')}>Open</Button>
        <Button variant="outlined" size="large" startIcon={<StopIcon />}
          sx={{ py: 2 }} onClick={() => send('STOPCURTAIN')}>Stop</Button>
        <Button variant="contained" size="large" startIcon={<ArrowDownwardIcon />}
          sx={{ py: 2 }} onClick={() => send('CLOSECURTAIN')}>Close</Button>
      </Stack>
    </DeviceShell>
  );
}
